module.exports = __webpack_public_path__ + "img/turfy3_fuji@2x.d4da659e.png";